import { PlusOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Flex, List, Skeleton, Typography } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import AvatarCustom from 'src/components/v2/Avatar';
import InviteTag from 'src/components/v2/Tag/InviteTag';
import { ITopicMember } from 'src/types/helpdesk/topic.type';
import { getFirstLetters } from 'src/utils/utils';
import AddTopicMember from './AddTopicMember';
import './TopicMember.scss';

const { Text } = Typography;

type Props = {
  members: ITopicMember[];
  loading: boolean;
};

const LIMIT = 3;

export default function TopicMember({ members: membersData, loading }: Props) {
  const [members, setMembers] = useState<ITopicMember[]>([]);
  const [isShow, setIsShow] = useState<boolean>(false);
  const [openAddMember, setOpenAddMember] = useState<boolean>(false);

  useEffect(() => {
    if (membersData && !isShow) {
      setMembers(membersData.slice(0, LIMIT));
    } else {
      setMembers(membersData);
    }
  }, [membersData, isShow]);

  const handleShowAll = () => {
    setIsShow(true);
  };
  const handleShowLess = () => {
    setMembers(membersData.slice(0, LIMIT));
    setIsShow(false);
  };

  return (
    <Fragment>
      <List
        className='list-member'
        footer={
          <Flex gap={8}>
            <Button icon={<PlusOutlined />} block onClick={() => setOpenAddMember(true)}>
              Mời thêm
            </Button>
            {membersData.length > LIMIT &&
              (!isShow ? (
                <Button icon={<DownOutlined />} block onClick={handleShowAll} className='btn-show'>
                  Xem tất cả
                </Button>
              ) : (
                <Button icon={<UpOutlined />} block onClick={handleShowLess} className='btn-show'>
                  Thu gọn
                </Button>
              ))}
          </Flex>
        }
        dataSource={members?.sort((a, b) => a.inviteType - b.inviteType)}
        renderItem={(item) => (
          <List.Item>
            <Skeleton avatar paragraph={{ rows: 0 }} title={{ width: '100%' }} active loading={loading}>
              <List.Item.Meta
                style={{ alignItems: 'center' }}
                avatar={
                  <AvatarCustom
                    size='medium'
                    background={item?.gradientBackground?.backgroundImage}
                    text={item?.id === '0' ? 'All' : getFirstLetters(String(item.employeeObj?.fullName))}
                  />
                }
                title={
                  <Text className='member-name'>{`${item.employeeObj?.fullName ?? ''} ${
                    item.userName ? `(${item.userName})` : ''
                  }`}</Text>
                }
                description={<Text className='member-department'>{item.employeeObj?.department?.name}</Text>}
              />
              <InviteTag inviteType={item.inviteType} />
            </Skeleton>
          </List.Item>
        )}
      />
      <AddTopicMember open={openAddMember} setOpen={setOpenAddMember} />
    </Fragment>
  );
}
